import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.replace";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';
import CodeInfo from '../components/CodeInfo';

var FunctionTerm =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FunctionTerm, _React$Component);

  function FunctionTerm() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FunctionTerm.prototype;

  _proto.getFunctionNameComponent = function getFunctionNameComponent(name) {
    return name.replace(/\((.*?)\)/g, function (value, params) {
      var replacedName = params.split(',').map(function (param) {
        return "<span class=\"param\">" + param + "</span>";
      });
      return "(" + replacedName + ")";
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        deprecated = _this$props.deprecated,
        override = _this$props.override,
        name = _this$props.name,
        codeInfo = _this$props.codeInfo;
    return React.createElement("h4", {
      className: "title"
    }, deprecated ? React.createElement("span", {
      className: "signiture deprecated"
    }, "deprecated") : null, override ? React.createElement("span", {
      className: "signiture override"
    }, "override") : null, React.createElement("span", {
      className: "name",
      dangerouslySetInnerHTML: {
        __html: this.getFunctionNameComponent(name)
      }
    }), React.createElement(CodeInfo, {
      data: codeInfo
    }));
  };

  return FunctionTerm;
}(React.Component);

export default FunctionTerm;